<template>
  <div class="LTTC">
  <div class="tracking-wider min-h-50 border borderColordarkgray2 rounded overflow-hidden px-4 md:px-8 py-6 md:py-8">
    <h3 class="text-NotoSansBold text-base lg:text-lg title mb-3 lg:mb-5 px-2 md:text-center">網際網路LTTC英文檢定練習服務契約</h3>
    <div class="text-NotoSansRegular">
      <div class="revise-title mb-6 leading-loose">
        <h5>立契約書人</h5>
        <h5>甲方：線上購買LTTC英檢練習之消費者（以下簡稱「甲方」）</h5>
        <h5>乙方：希伯崙股份有限公司（以下簡稱「乙方」）</h5>
        <h5>負責人：鄭俊琪</h5>
      </div>
      <div class="revise-body text-NotoSansRegular text-sm">
        <div v-for="(item, index) in contract" :key="index" class="mb-8">
          <h5 class="font-bold">{{ item.title }}</h5>
          <ul class="list-none list-inside mt-4 ml-2"  v-if="item.detail">
            <li v-for="(child, idx) in item.detail" :key="idx">{{ child.text }}
              <ul class="list-inside mt-4 ml-2" v-if="child.textDetail">
                <li v-for="(children, idx) in child.textDetail" :key="idx">{{ children.text }}</li>
              </ul>
            </li>
          </ul>
          <h5 v-if="item.thirdTitle">{{ item.thirdTitle }}</h5>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'LTTC',
  metaInfo () {
    return {
      title: '網際網路LTTC英文檢定練習服務契約',
      titleTemplate: null
    }
  },
  data () {
    return {
      contract: [
        {
          title: '第一條（本服務之定義）',
          detail: [
            { text: '乙方授權甲方利用網際網路連線方式，使用乙方於其指定的網站系統上所提供之「LTTC英文檢定練習」教學服務及其他相關服務（以下簡稱「本服務」）。' },
            { text: '甲乙雙方關於本服務之權利義務，依本契約條款之約定訂之。' }
          ]
        },
        {
          title: '第二條（本服務內容）',
          secondTitle: '本服務內容包括以下各款：',
          detail: [
            { text: '乙方提供本服務之網站網址：http://gept.liveabc.com/' },
            { text: '乙方提供本服務之對象：對全民英語能力分級檢定測驗有需求與興趣者。' },
            { text: '乙方提供本服務之內容：LTTC財團法人語言訓練測驗中心官方授權考古題。' },
            { text: '乙方提供本服務之功能：',
              textDetail: [
                { text: '全民英檢初試考古題之模考練習。' },
                { text: '考後提供解題關鍵、重要字彙等資訊。' },
                { text: '線上提供GEPT、CSEPT官方考試相關資訊。' },
                { text: '各級聽力題目皆由專業老師錄音，模擬考試情境。' }
              ]
            },
            { text: '乙方提供之本服務教學課程數量如下，各等級各別銷售，甲方可視實際需求訂購：',
              textDetail: [
                { text: '全民英檢初級初試(聽力及閱讀測驗) 6回。' },
                { text: '全民英檢中級初試(聽力及閱讀測驗) 6回。' },
                { text: '全民英檢中高級初試(聽力及閱讀測驗) 6回' }
              ]
            }
          ]
        },
        {
          title: '第三條（設備規格）',
          detail: [
            { text: '甲方硬體需求：',
              textDetail: [
                { text: '最低配備：CPU Pentium 4以上、記憶體1GB以上、硬碟剩餘空間1GB以上。' },
                { text: '網路設備：ADSL或是CableModem或任何Intertnet專線。' },
                { text: '螢幕解析度：1024*768顯示能力之顯示卡及顯示器。' },
                { text: '其他週邊需求：音效卡。' }
              ]
            },
            { text: '甲方軟體需求：',
              textDetail: [
                { text: '最低配備：Windows 7以上之作業系統。' },
                { text: '瀏覽器：建議Internet Explorer10以上的版本或是Google Chrome瀏覽器。' },
                { text: '甲方連線需求：下載速度8 Mbps以上之寬頻網路。' }
              ]
            }
          ],
          thirdTitle: '以上設備規格為線上使用本服務之最低需求建議，惟乙方無法保證甲方實際使用操作上之狀況。'
        },
        {
          title: '第四條（本契約之成立）',
          detail: [
            { text: '甲方經由網際網路申請本服務者，於乙方所指定網頁上點選「同意」鍵後，視為同意購買本服務，本契約即成立。' }
          ]
        },
        {
          title: '第五條（服務序號密碼）',
          detail: [
            { text: '甲方於線上完成付款程序後，乙方應於三個工作天內，以甲方登記之E-mail提供本服務之「帳號啟用通知（內含一組開卡序號及密碼）」。' }
          ]
        },
        {
          title: '第六條（使用權之取得）',
          detail: [
            { text: '甲方於收受前條通知之日起，取得本服務之使用權。乙方得請求甲方於乙方所指定之網頁上，註冊與甲方身分證明文件相符之必要個人資料，並設定使用者帳號及個人密碼，以便乙方於甲方使用本服務時，確認甲方之身分。' },
            { text: '甲方如未收到前條通知，應於付款後七日內主動告知乙方，逾期不得再向乙方主張任何權利。' }
          ]
        },
        {
          title: '第七條（使用權之限制）',
          detail: [
            { text: '乙方授權甲方依本契約之約定，對於本服務享有非專屬之使用權。' },
            { text: '未經乙方事前之書面同意，甲方不得將其使用權轉讓第三人或再授權第三人使用。' }
          ]
        },
        // rr
        {
          title: '第八條（七天猶豫期之排除說明）',
          detail: [
            { text: '甲方瞭解並同意本服務屬「通訊交易解除權合理例外情事適用準則」所定之「非以有形媒介提供之數位內容或一經提供即為完成之線上服務」，得排除消費者保護法第十九條規定七天猶豫期之適用。但甲方如未曾使用序號及密碼登入帳號，欲申請退費者，應於收受第五條「帳號啟用通知」後七日內撥打乙方客服專線（電話：02-25787838)申請退費，經乙方查證屬實後，將全額退費。' }
          ]
        },
        {
          title: '第九條（授權期間或使用權利）',
          detail: [
            { text: '乙方授權甲方使用本服務之期間、次數或權利依下列之約定：',
              textDetail: [
                { text: '甲方於收受本服務之服務序號及密碼，取得本服務使用權之次日起，為期180日之使用期間。' },
                { text: '甲方於上述期間內享有不計次數、每次不計時間之使用權。' },
                { text: '甲方於取得本服務使用權後，不得再對授權期間長短為異議或要求延長或暫停。' }
              ]
            }
          ]
        },
        {
          title: '第十條（授權使用規則）',
          detail: [
            { text: '甲方有下列情形之一者，由甲方自負一切法律責任，乙方並得通知甲方終止本契約，甲方不得拒絕：',
              textDetail: [
                { text: '甲方蓄意散佈干擾乙方網路系統正常運作之電腦程式。' },
                { text: '甲方在乙方網路系統上散佈恐嚇、毀謗、侵犯他人隱私、色情或其他違反公序良俗之文字、圖片或影像。' }
              ]
            },
            { text: '甲方利用本服務從事其他不法或違反本契約約定事項之行為，其情節重大，且經乙方通知甲方限期改正而未改正者，乙方亦得通知甲方終止本契約，甲方不得拒絕。' },
            { text: '乙方依前二項約定終止本契約時，甲方不得向乙方主張一部或全部退費。' }
          ]
        },
        {
          title: '第十一條（甲方之責任）',
          detail: [
            { text: '甲方對於使用本服務所產生之授權使用費，在甲方依第四條點選「同意」鍵，進入付費流程後，即有繳納之義務。' },
            { text: '甲方對於其使用者帳號與個人密碼有妥善保管以避免第三人知悉之義務。如因甲方怠於保密而致其帳號密碼外洩者，應由甲方自行負責。' },
            { text: '甲方在使用本服務時，有遵守本契約第十條所約定之授權使用規則之義務。' },
            { text: '甲方依本契約第六條之約定所註冊之個人資料如有錯誤或已變更時，甲方應隨時通知乙方請求更正。如因甲方怠於通知而致其權益受損，應由甲方自行負責。' }
          ]
        },
        {
          title: '第十二條（帳號密碼非法使用之處理）',
          detail: [
            { text: '利用甲方之使用者帳號與個人密碼，登入本服務電腦系統之行為，推定為甲方之行為。' },
            { text: '雙方當事人之任何一方，如發現甲方之使用者帳號或個人密碼遭第三人非法使用，應立即通知對方，經甲方確認有遭第三人非法使用之情事，乙方應立即暫停該使用者帳號或個人密碼之使用，並接受甲方更換其使用者帳號或個人密碼。' },
            { text: '前項情形，如甲方能證明係非因可歸責於甲方之事由，致其使用者帳號或個人密碼遭第三人非法使用所生之損失者，得請求乙方於七日內延長甲方之使用期間做為補償。' }
          ]
        },
        {
          title: '第十三條（智慧財產權）',
          detail: [
            { text: '甲方應尊重與本服務有關之所有智慧財產權，非經乙方及智慧財產權人事前書面同意，甲方不得以本契約授權以外之其他方式加以利用。' },
            { text: '甲方違反前項之約定者，乙方得終止契約，甲方不得拒絕或請求退還費用之一部或全部，並應依法賠償乙方及智慧財產權人因此所受之損害。' }
          ]
        },
        {
          title: '第十四條（乙方保密義務）',
          detail: [
            { text: '乙方因提供本服務而知悉或持有甲方之學習紀錄或其他個人資料，乙方負有保密義務，除甲方請求查詢或第三人依據個人資料保護相關法令請求查詢者外，乙方不得對任何第三人揭露。' }
          ]
        },
        {
          title: '第十五條（乙方免責事由）',
          detail: [
            { text: '乙方不得因第三人入侵其電腦系統，而免除乙方對甲方所應負之損害賠償責任。但乙方已盡善良管理人之注意義務，就提供本服務之各項軟硬體設備，已依當時國內之技術程度，提供完善的安全防護措施及定期安全漏洞偵測與修補，而仍無法避免發生者，不在此限。' },
            { text: '除本契約或乙方之廣告另有保證使用本服務之學習成效外，乙方不保證甲方使用本服務之學習成效。' }
          ]
        },
        {
          title: '第十六條（暫停服務之處理）',
          detail: [
            { text: '乙方對於本服務相關軟硬體設備，進行營運上必要之搬遷、更換、升級、保養或維修時，得暫停本服務之全部或一部。' },
            { text: '乙方因前項事由而暫停本服務之全部或一部，乙方應於暫停本服務七日前，於本服務網站首頁上及本服務進行中公告，並以電子郵件或書面通知甲方。但因天災、事變、無預警停電或主機不正常當機等突發事件所致者，不在此限。' },
            { text: '乙方於恢復本服務後，經甲方申請，得准以延長甲方相當於實際暫停服務期間之使用期間做為補償。' }
          ]
        },
        {
          title: '第十七條（個人資料之保護）',
          detail: [
            { text: '乙方對於甲方個人資料之蒐集、處理及利用，應取得甲方事前之書面同意，並依誠實及信用方法為之，不得逾越本契約目的之必要範圍，且應與蒐集之目的具有正當合理之關聯。' },
            { text: '乙方為維護甲方個人資料之正確，應依甲方之請求即時更正或補充之。甲方個人資料正確性有爭議者，乙方應即時停止該個人資料之處理及利用或採取其他保護措施。' },
            { text: '除法律另有規定者外，乙方不得將甲方個人資料為本契約目的必要範圍外之利用，並不得將甲方個人資料於乙方關係企業之不同法人間流通。' }
          ]
        },
        {
          title: '第十八條（契約之變更）',
          detail: [
            { text: '甲方不得片面變更本契約條款內容。' },
            { text: '本契約條款內容如有任何變更，乙方應以電子郵件通知甲方，甲方應於收受通知後三日內，表示是否同意，甲方未為表示者，視為同意。' }
          ]
        },
        {
          title: '第十九條（終止契約）',
          detail: [
            { text: '甲方於使用期間屆滿時，本契約即告終止。' }
          ]
        },
        {
          title: '第二十條（不可抗力事件）',
          detail: [
            { text: '因不可抗力事件，致本契約無法履行者，乙方得通知甲方終止本契約。本契約終止後，經甲方申請，乙方得准予按比例返還甲方相當於終止契約前尚未使用之本服務授權使用費金額。' }
          ]
        },
        {
          title: '第二十一條（乙方之申訴）',
          detail: [
            { text: '甲方對於乙方所提供之本服務，除得撥打乙方電話提出申訴外，亦得以電子郵件或書面，或至乙方之營業處所向乙方提出申訴，乙方應自接獲甲方申訴之日起十五日內妥適處理之。' }
          ]
        },
        {
          title: '第二十二條（準據法）',
          detail: [
            { text: '因本契約所生之一切爭議，雙方當事人約定適用中華民國法律。' }
          ]
        },
        {
          title: '第二十三條（契約之解釋）',
          detail: [
            { text: '本契約條款內容如有疑義時，乙方有解釋之權。' }
          ]
        },
        {
          title: '第二十四條（管轄法院）',
          detail: [
            { text: '因本契約所生之一切爭議，雙方當事人同意以台灣台北地方法院為第一審管轄法院。' }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  ul {
    list-style-type: cjk-ideographic;
    li {
      margin-bottom: 1rem;
    }
  }
</style>
